<template>
<div class="container-login">
    <!-- <img :src="require('@/assets/menu/settings.png')" /> -->
    <div class="loginimagemdir">
        <img :src="require('@/assets/login_bonecos/dir.svg')" />
    </div>
    <div class="loginimagemesq">
        <img :src="require('@/assets/login_bonecos/esq.svg')" />
    </div>
    <div class="maincontainer-login">
        <div class="buttons-login">
            <button class="login-loginpage"> {{$t('menu.login.login')}} </button>
            <button @click="$emit('create')" class="create-loginpage"> {{$t('menu.login.create')}} </button>
        </div>
        <form id="login" @submit="checkForm" method="post" novalidate="true" class="form-login">
            <div class="container-loginpage">
                <div class="input-login">

                    <input name="username" id="username" type="text" placeholder="Username" v-model="username" class="input-loginpage" />

                    <input name="password" id="password" type="password" placeholder="Password" v-model="password" class="input-loginpage" />
                </div>
            </div>
            <button type="submit" value="Submit" class="start-loginpage">
                {{$t('menu.login.button')}} </button>
        </form>

        <!-- botao guest -->
        <div class="botao-horizontal">
            <button class="start-loginpage start-guest" @click="$emit('enter', 'guest')"> {{$t('menu.login.guest')}} </button>

            <a class="start-loginpage start-about" href="http://copoem.esalab.es"> {{$t('menu.login.about')}} </a>

        </div>
    </div>

    <div class="avisos-loginpage">
        <span class="popupUsername-loginpage popup-login">
            <img :class="{ 'hidden-create' : erroUsername == false }" :src="require('@/assets/menu/errorBox.svg')" />
            <span class="error-loginpage" v-if="erroUsername"> {{ errorUser }} </span>
        </span>
        <span v-if="erroPass" class="popupPass-loginpage popup-login">
            <img :class="{ 'hidden-login' : erroPass == false }" :src="require('@/assets/menu/errorBox.svg')" />
            <span class="error-loginpage" v-if="erroPass"> {{ errorPass }} </span>
        </span>
        <span v-else-if="erroWrongPass" class="popupPass-loginpage popup-login">
            <img :class="{ 'hidden-login' : erroWrongPass == false }" :src="require('@/assets/menu/errorBox.svg')" />
            <span class="error-loginpage" v-if="erroWrongPass"> {{ errorWrongPass }} </span>
        </span>
    </div>

</div>
</template>

<script>
export default {
    name: "Login",
    emits: ['enter', 'create'],
    components: {},
    data() {
        return {
            erros: [],
            erroUsername: false,
            erroPass: false,
            erroWrongPass: false,
            errorUser: '',
            errorPass: '',
            errorWrongPass: '',
            username: '',
            password: ''
        }
    },
    methods: {
        checkForm: function (e) {
            this.erros = [];

            if (!this.username) {
                this.erroUsername = true;
                this.errorUser = 'Username required.'
            } else {
                this.erroUsername = false;
            }

            if (this.password) {
                this.erroPass = false;
            } else if (!this.password) {
                this.errorPass = 'Password required.'
                this.erros.push('erro2')
                this.erroPass = true;
            }

            if (!this.erros.length) {
                this.loginAuth();
            }
            e.preventDefault();
            console.log(this.erros);
        },

        loginAuth() {
            let UserForm = new FormData();
            UserForm.append('username', this.username);
            UserForm.append('password', this.password);
            fetch(process.env.VUE_APP_API_URL + "/auth/token", {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "*",
                        Accept: "application/json, text/plain, *//**",
                    },
                    method: "POST",
                    body: UserForm
                }).then((res) => {
                    return res.json();
                })
                .then((devs) => {
                    if (!devs['signed-in']) {
                        this.erroWrongPass = true;
                        this.errorWrongPass = 'Incorrect Password';
                    } else {
                        this.$emit('enter', devs);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    error = true;
                });
        }
    },
};
</script>

<style>
.container-login {
    pointer-events: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-family: Omnes;
    font-style: normal;
    /*background-color: white; */
}

.loginimagemesq {
    width: 35%;
    float: left;
    position: absolute;
    margin-left: -6%;
    margin-top: 70%;
    bottom: 0;

}

.loginimagemdir {
    width: 40%;
    float: right;
    position: absolute;
    margin-left: 70%;
    margin-top: 70%;
    bottom: 0;
}

.container-login>img {

    z-index: -1;
    position: absolute;

}

.container-login>* {
    pointer-events: auto;
    flex-shrink: 0;
}

.container-loginpage {
    padding: 0.2rem;
    border-radius: 20px;
}

.maincontainer-login {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.3s ease;
    top: 0;
    z-index: 100;
}

@keyframes startlogin {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 100;
    }
}

.buttons-login {
    width: 42%;
    display: flex;
    justify-content: space-between;
}

.form-login {
    width: 42%;
    margin-top: 2%;
    text-align: center;
}

.login-loginpage {
    font-family: Omnes;
    border: none;
    padding: 3%;
    width: 45%;
    background-color: black;
    color: white;
    /* não é*/
    border-radius: 30px;
    font-style: normal;
    font-weight: bold;
    font-size: 1rem;
}

.create-loginpage {
    background-color: white;
    color: black;
    /* não é*/
    border: solid black;
    border-radius: 30px;
    padding: 3%;
    width: 45%;
    font-style: normal;
    font-weight: bold;
    font-family: Omnes;
    font-size: 1rem;
}

.start-loginpage {
    margin-top: 4%;
    background-color: black;
    color: white;
    /* não é*/
    border: none;
    border-radius: 30px;
    padding: 3%;
    width: 40%;
    font-family: Omnes;
    font-weight: bold;
    font-style: normal;
    font-size: 1rem;
}

.botao-horizontal {
    margin-top: 1.5%;
    display: flex;
    width: 42%;
    justify-content: space-between;
}

.start-about {
    width: 39%;
    padding: 3%;

    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    text-decoration: none;

    text-align: center !important;
    /*border-radius: 30px !important;*/
    border: 3px solid black !important;

    background: black !important;
    box-shadow: 0px 0px 0px transparent !important;
    /*border: 0px solid transparent !important; */
    text-shadow: 0px 0px 0px transparent !important;
}

.start-guest {
    width: 45%;
    padding: 3%;

    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    text-decoration: none;

    text-align: center;
    /*border-radius: 30px;*/
    border: 3px black;
}

::placeholder {
    color: black;
    /* não é*/
    font-family: Omnes;
}

.input-login {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-evenly;
}

.error-loginpage {
    color: white;
    /* não é*/
    position: absolute;
    left: 83%;
    margin-top: 1.5%;
    width: 100%;
}

.avisos-loginpage {
    position: absolute;
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: -3.5%;
    position: absolute;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    top: 0;
}

.popup-login {
    width: 21%;
    margin-bottom: 1%;
}

.popup-login>img {
    width: 100%;
}

.input-loginpage {
    padding: 3%;
    margin: 2% 2%;
    background-color: white;
    border: black solid;
    border-radius: 30px;
    color: black;
    /* não é*/
    font-family: Omnes;
    font-weight: bold;
    font-style: normal;
}

.hidden-login {
    visibility: hidden;
}

@media only screen and (max-width: 480px) {
    .buttons-login {
        top: 16%;
    }

    .login-loginpage {
        font-size: 0.5rem;
    }

    .create-loginpage {
        font-size: 0.5rem;
    }

    .start-loginpage {
        font-size: 0.5rem;
    }

    .input-loginpage {
        font-size: 0.4rem;
    }

    .error-loginpage {
        font-size: 0.4rem;
    }
}

@media only screen and (min-width: 480px) and (max-width: 550px) {
    .buttons-login {
        top: 16%;
    }

    .login-loginpage {
        font-size: 0.6rem;
    }

    .create-loginpage {
        font-size: 0.6rem;
    }

    .start-loginpage {
        font-size: 0.6rem;
    }

    .input-loginpage {
        font-size: 0.5rem;
    }

    .error-loginpage {
        font-size: 0.5rem;
    }
}

@media only screen and (min-width: 550px) and (max-width: 630px) {
    .login-loginpage {
        font-size: 0.7rem;
    }

    .create-loginpage {
        font-size: 0.7rem;
    }

    .start-loginpage {
        font-size: 0.7rem;
    }

    .input-loginpage {
        font-size: 0.6rem;
    }

    .error-loginpage {
        font-size: 0.6rem;
    }
}

@media only screen and (min-width: 630px) and (max-width: 718px) {
    .login-loginpage {
        font-size: 0.8rem;
    }

    .create-loginpage {
        font-size: 0.8rem;
    }

    .start-loginpage {
        font-size: 0.8rem;
    }

    .input-loginpage {
        font-size: 0.7rem;
    }

    .error-loginpage {
        font-size: 0.7rem;
    }
}

@media only screen and (min-width: 718px) and (max-width: 806px) {
    .login-loginpage {
        font-size: 0.9rem;
    }

    .create-loginpage {
        font-size: 0.9rem;
    }

    .start-loginpage {
        font-size: 0.9rem;
    }

    .input-loginpage {
        font-size: 0.8rem;
    }

    .error-loginpage {
        font-size: 0.8rem;
    }
}

@media only screen and (min-width: 806px) and (max-width: 1024px) {
    .login-loginpage {
        font-size: 1rem;
    }

    .create-loginpage {
        font-size: 1rem;
    }

    .start-loginpage {
        font-size: 1rem;
    }

    .input-loginpage {
        font-size: 0.9rem;
    }

    .error-loginpage {
        font-size: 0.9rem;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {
    .login-loginpage {
        font-size: 1.1rem;
        border-radius: 45px;
    }

    .create-loginpage {
        font-size: 1.1rem;
        border-radius: 45px;
    }

    .start-loginpage {
        font-size: 1.1rem;
        border-radius: 45px;
    }

    .input-loginpage {
        font-size: 1rem;
    }

    .container-login {
        border-radius: 35px;
    }

    .error-loginpage {
        font-size: 1rem;
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {
    .login-loginpage {
        font-size: 1.2rem;
        border-radius: 45px;
    }

    .create-loginpage {
        font-size: 1.2rem;
        border-radius: 45px;
    }

    .start-loginpage {
        font-size: 1.2rem;
        border-radius: 45px;
    }

    .input-loginpage {
        font-size: 1.1rem;
    }

    .container-login {
        border-radius: 35px;
    }

    .error-loginpage {
        font-size: 1.1rem;
    }
}

@media only screen and (min-width: 1366px) and (max-width: 1540px) {
    .login-loginpage {
        font-size: 1.3rem;
        border-radius: 45px;
    }

    .create-loginpage {
        font-size: 1.3rem;
        border-radius: 45px;
    }

    .start-loginpage {
        font-size: 1.3rem;
        border-radius: 45px;
    }

    .input-loginpage {
        font-size: 1.2rem;
    }

    .container-login {
        border-radius: 35px;
    }

    .error-loginpage {
        font-size: 1.2rem;
    }
}

@media only screen and (min-width: 1540px) and (max-width: 1680px) {
    .login-loginpage {
        font-size: 1.4rem;
        border-radius: 45px;
    }

    .create-loginpage {
        font-size: 1.4rem;
        border-radius: 45px;
    }

    .start-loginpage {
        font-size: 1.4rem;
        border-radius: 45px;
    }

    .input-loginpage {
        font-size: 1.3rem;
    }

    .container-login {
        border-radius: 35px;
    }

    .error-loginpage {
        font-size: 1.3rem;
    }
}

@media only screen and (min-width: 1680px) and (max-width:2350px) {
    .login-loginpage {
        font-size: 1.5rem;
        border-radius: 70px;
    }

    .create-loginpage {
        font-size: 1.5rem;
        border-radius: 70px;
    }

    .start-loginpage {
        font-size: 1.5rem;
        border-radius: 70px;
    }

    .input-loginpage {
        font-size: 1.4rem;
    }

    .container-login {
        border-radius: 35px;
    }

    .error-loginpage {
        font-size: 1.4rem;
    }
}

@media only screen and (min-width: 2350px) and (max-width: 2550px) {
    .login-loginpage {
        font-size: 1.8rem;
        border-radius: 70px;
    }

    .create-loginpage {
        font-size: 1.8rem;
        border-radius: 70px;
    }

    .start-loginpage {
        font-size: 1.8rem;
        border-radius: 70px;
    }

    .input-loginpage {
        font-size: 1.7rem;
    }

    .container-login {
        border-radius: 35px;
    }

    .error-loginpage {
        font-size: 1.7rem;
    }
}

@media only screen and (min-width: 2550px) {
    .login-loginpage {
        font-size: 3rem;
        border-radius: 100px;
    }

    .create-loginpage {
        font-size: 3rem;
        border-radius: 100px;
    }

    .start-loginpage {
        font-size: 3rem;
        border-radius: 100px;
    }

    .input-loginpage {
        font-size: 2.9rem;
    }

    .container-loginpage {
        border-radius: 40px;
    }

    .error-loginpage {
        font-size: 2.8rem;
    }
}
</style>
